module.exports = __webpack_public_path__ + "static/media/sv.pictogram.6e6d50b0.svg";